import React from 'react'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import InnerForm from '@Fields/v2/InnerForm'
import { FormFieldType } from '@App/forms/v2/common/form-field'

interface CreatePublisherDetailsProps {
    publisherName: FormFieldType<string>
    ipiNumber: null | FormFieldType<string>
    isAdministrator: boolean
}

const CreatePublisherDetails = (props: CreatePublisherDetailsProps) => {
    const { publisherName, ipiNumber, isAdministrator } = props
    return (
        <>
            <h5 className="medium subtitle">
                Enter the {isAdministrator ? 'administrator' : 'publisher'}&apos;s details.
            </h5>
            <h5 className="medium subtitle">
                The Create Publisher button is only for Members who intend to list their Member name as the
                administrator on behalf of a publisher.
            </h5>

            <InnerForm formFields={{ publisherName, ipiNumber }} />
            <p>
                If your Member name is not your publisher name and needs to be updated, please click{' '}
                <NavLink className="Link" to={Navigation.contactUs.root()} target="_blank" rel="noopener noreferrer">
                    here{' '}
                </NavLink>
                to contact Support.
            </p>
        </>
    )
}
export default CreatePublisherDetails
